// tslint:disable-next-line
const currencyFormatter = require('currency-formatter');

interface ICurrencyFormatOptions {
  decimals?: number;
}

export const currencyRoundFormat = (price: number, currencyCode: string, options?: ICurrencyFormatOptions) => {
  
  let thousand: string = ' ';
  let decimal: string = ',';

  switch (currencyCode.toLowerCase()) {
    case 'eur':
    case 'gbp':
      thousand = '.';
      break;
    case 'usd':
    case 'cad':
    case 'aud':
      thousand = ',';
      decimal = '.';
      break;
    default:
      thousand = '.';
      break;
  }

  const option = {
    code: currencyCode,
    thousand,
    decimal,
    precision: options && options.decimals
      ? options.decimals
      : (currencyCode.toLowerCase() === 'czk' ? 0 : 2),
  };
  
  return currencyFormatter.format(price, option);
};


// WEBPACK FOOTER //
// ../helpers/src/currency/currencyRoundFormat.ts